import CrosswordPuzzle from "../components/Crossword/Crossword"
import React from "react"
const Crossword = () => {
    
  return (
    <div>
        <CrosswordPuzzle/>

    </div>
  )
}

export default Crossword